<template>
  <transition name="modal">
    <div class="modal-mask">
      <div class="modal-wrapper">
        <div class="modal-container">

          <div class="modal-header">
            <slot name="header">
              Clear infractions
            </slot>
          </div>

          <div class="modal-body">
            <slot name="body">
              Clear {{student.length == 1 ? student[0].name + "'s" : "all"}} infractions?
            </slot>
          </div>

          <div class="modal-footer">
            <slot name="footer">
                <button type="button" class="btn btn-secondary" @click="$emit('close')">Cancel</button>
                <button type="button" class="btn btn-primary"  @click="clearInfractions(student)">Yes, clear</button>
            </slot>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>


<script>
import { db } from '@/main.js'

export default {
    name: "ClearModal",
    props: {student: Array},
    methods: {
        clearInfractions: function(student) {
          student.forEach(s => {
            if (s.org === this.$root.sharedState.org) {
              var studentRef = db.collection('students').doc(s.id);
              studentRef.update({
                infractions: [],
                infractionCounter: 0
              })
            }
          })  
            this.$emit('close')
        },
    }
}
</script>